module.exports = __webpack_public_path__ + "img/yw_ydqs.93718c6b.svg";